module.exports = __webpack_public_path__ + "static/hermione-3badf4221ac8b843f4104dd1d8543b5f.gif";